import React,{ useRef, useEffect, useState } from "react";
import FeatureSnappingLayerSource from "@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource.js";
import Collection from "@arcgis/core/core/Collection.js";
import SnappingOptions from "@arcgis/core/views/interactive/snapping/SnappingOptions.js";
import { Box, Checkbox, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { observerAddToHandles, observerHandles } from "../../../handles/Handles";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

const SnappingControlsWidget =({view, activeWidget, sketchViewModel,handleName })=> {
    const [visible, setVisible] = useState(false)
    const[snappingEnabled,setSnappingEnabled]=useState(false)
    const [OptionsDictionary, setOptionsDictionary]=useState({})
    const snappingControlsWidgetDiv = useRef(null);

    useEffect(() => {
        if (activeWidget === "snappingOptions") {
          setVisible(true);
        } else {
          setVisible(false);
        }
    }, [activeWidget]);

    let style = { display: "initial" };

    if (visible) {
        style.display = "initial";
    } else {
        style.display = "none";
    }

    useEffect(() => {
      //instantiate snapping options for the Sketch View Model. Set up dictionary of layers to snap to.
        if(sketchViewModel && snappingControlsWidgetDiv.current){
            sketchViewModel.snappingOptions=new SnappingOptions({
                enabled:true,
                featureSources:new Collection(),
            });
            setSnappingEnabled(sketchViewModel.snappingOptions.enabled)
            let newDict={}
            view.map.allLayers.forEach((layer)=>{
              if(layer.type==='feature' && layer.visible){
                newDict[layer.id]={name:layer.title,id:layer.id,enabled:false}
              }   
            })
            setOptionsDictionary(newDict)
         }
    }, [sketchViewModel]);

    useEffect(() => {
      if(!view.map){
        return
      }
      observerAddToHandles(
        reactiveUtils.watch(
          () => view.map.allLayers.map(layer => layer.visible),
          () => {
            setOptionsDictionary(prevState => {
              const dictShallowCopy = { ...prevState };
    
              view.map.allLayers.forEach(layer => {
                if (layer.type === "feature") {
                  if (Object.hasOwnProperty.call(dictShallowCopy, layer.id)) {
                    if (!layer.visible) {
                      delete dictShallowCopy[layer.id];
                      let sketchViewSnapSource=sketchViewModel.snappingOptions.featureSources.find(src=>{
                        return src.layer.id===layer.id
                      })
                      if(sketchViewSnapSource){
                        sketchViewModel.snappingOptions.featureSources.remove(sketchViewSnapSource)
                      }
                    }
                  } else {
                    if (layer.visible) {
                      dictShallowCopy[layer.id] = {
                        id: layer.id,
                        enabled: false,
                        name: layer.title,
                      };
                    }
                  }
                }
              });
    
              return dictShallowCopy;
            });
          }
        ),
        "reRenderSnappingControlList"+handleName
      );
      return()=>{
        observerHandles.remove("reRenderSnappingControlList"+handleName)
      }
    }, []);
    

    let checkBoxList=[];
    if(sketchViewModel){
    let dictArray=Object.keys(OptionsDictionary).map(key=>OptionsDictionary[key])
    dictArray.sort((a,b)=>{
          if(a.name<b.name){
              return -1
          }
          if(a.name>b.name){
              return 1
          }
          return 0
      })
    const list = dictArray.map((item) => {
        return (
          <div key={item.id}>
            <FormControlLabel
            control={<Checkbox
              checked={item.enabled}
              onChange={() => {
                let featSrcLyr=sketchViewModel.snappingOptions.featureSources.find(src=>{
                  if(src.layer.id===item.id){
                    return src
                  }
                })
                if(featSrcLyr){
                  featSrcLyr.enabled=!featSrcLyr.enabled
                }else{
                  let newLyr=view.map.allLayers.find((layer)=>{
                    return layer.id===item.id
                  })
                  sketchViewModel.snappingOptions.featureSources.add(new FeatureSnappingLayerSource({
                        layer:newLyr,
                        enabled:true
                    }));
                }
                
                setOptionsDictionary((prevState) => {
                  const updatedOptionsDictionary = {
                    ...prevState,
                    [item.id]: {
                      ...prevState[item.id],
                      enabled: !prevState[item.id].enabled,
                    },
                  };
                  return updatedOptionsDictionary;
                });
              }}
            />}
            label={item.name}
            />
          </div>
        );
      });
      checkBoxList=list
}
    return (
        <div ref={snappingControlsWidgetDiv} style={style}>
          <Box component="form">
          <FormGroup>
          <FormControlLabel control={<Switch checked={snappingEnabled} onChange={()=>{
                setSnappingEnabled(prev=>!prev);
                sketchViewModel.snappingOptions.enabled=!sketchViewModel.snappingOptions.enabled
            }}></Switch>} label="Enable Snapping"/>
            </FormGroup>
            <FormGroup>
            {snappingEnabled && checkBoxList}
            </FormGroup>
            </Box>
        </div>
    );
}

export default SnappingControlsWidget